import { render, staticRenderFns } from "./GeoPopup.vue?vue&type=template&id=f6072f72&scoped=true&"
import script from "./GeoPopup.vue?vue&type=script&lang=js&"
export * from "./GeoPopup.vue?vue&type=script&lang=js&"
import style0 from "./GeoPopup.vue?vue&type=style&index=0&id=f6072f72&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6072f72",
  null
  
)

export default component.exports